import React from 'react';
import InnerPageBanner from '../../../components/InnerPageBanner';
import { Box, Container, Typography, Grid } from '@mui/material';
import { handleImageClick } from '../../../utils/imageUtils';

// Import all 5 pergola stone images
import pergola1 from "../../../assets/images/Pergola Stone1.jpeg";
import pergola2 from "../../../assets/images/Pergola Stone2.jpeg";
import pergola3 from "../../../assets/images/Pergola Stone3.jpeg";
import pergola4 from "../../../assets/images/Pergola Stone4.jpeg";
import pergola5 from "../../../assets/images/Pergola Stone5.jpeg";

// Create array of all images
const pergolaImages = [
    pergola1, pergola2, pergola3, pergola4, pergola5
];

const Pergola = () => {
    return (
        <Box>
            <InnerPageBanner title="Pergola" image={pergola1} />
            <Container sx={{ py: 5 }}>

                <Box sx={{
                    backgroundColor: "#f5f5f5",
                    py: { xs: 4, md: 6 },
                    px: { xs: 2, md: 4 },
                    borderRadius: 2
                }}>
                    {/* ===== Top Hero Section ===== */}
                    <Box
                        sx={{
                            backgroundColor: "#eaeaea",
                            p: { xs: 3, sm: 5, md: 8 },
                            mb: { xs: 5, md: 8 },
                            borderRadius: 2
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{ color: "#777", mb: 2, fontSize: { xs: 12, md: 14 } }}
                        >
                            No Doubt We Are Trusted
                        </Typography>

                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: { xs: 24, sm: 28, md: 36 }
                            }}
                        >
                            Pergola
                        </Typography>

                        <Box
                            sx={{
                                width: 50,
                                height: 3,
                                backgroundColor: "#1abc9c",
                                my: 2
                            }}
                        />

                        <Box sx={{ mt: 3 }}>
                            <Typography sx={{ fontSize: { xs: 13, md: 14 } }}>
                                <strong>Available Color</strong><br />
                                Grey (White)
                            </Typography>
                        </Box>
                    </Box>

                    {/* ===== Image Gallery Section ===== */}
                    <Typography
                        sx={{
                            fontWeight: 700,
                            mb: 3,
                            fontSize: { xs: 20, md: 24 }
                        }}
                    >
                        Our Pergola Models
                    </Typography>

                    <Box sx={{ width: 40, height: 3, backgroundColor: "#1abc9c", mb: 4 }} />

                    <Grid container spacing={4}>
                        {/* All 5 Images in Grid */}
                        {pergolaImages.map((image, index) => (
                            <Grid size={{ xs: 12, sm: 6, md: 6 }} key={index}>
                                <Box
                                    component="img"
                                    src={image}
                                    alt={`Pergola ${index + 1}`}
                                    onClick={() => handleImageClick(image)}
                                    sx={{
                                        width: "100%",
                                        height: { xs: 200, sm: 220, md: 250 },
                                        objectFit: "cover",
                                        border: "1px solid #ccc",
                                        borderRadius: 2,
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                        cursor: 'pointer',
                                        transition: 'transform 0.3s',
                                        '&:hover': {
                                            transform: 'scale(1.02)',
                                            boxShadow: '0 8px 20px rgba(0,0,0,0.15)'
                                        }
                                    }}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
};

export default Pergola;